export default "__VITE_ASSET__D1c4VRVv__"